import {
    Box,
    Card,
    Container,
    Stack,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Link,
    Button,
    TextField
} from '@mui/material';
import { initializeApp } from 'firebase/app';
import { doc, getDoc, setDoc, getFirestore } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReusableDialog from 'src/components/ReusableDialog';
import { FIREBASE_API } from 'src/config';
import useSettings from 'src/hooks/useSettings';

const ViewWholeSaleCustomer = () => {
    const [searchParams] = useSearchParams();
    const { themeStretch } = useSettings();
    const [currentCustomer, setCurrentCustomer] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDisapproveVisible, setIsDisapproveVisible] = useState(false);
    const [disapproveReason, setDisapproveReason] = useState("");
    const [status, setStatus] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState('');
    const [dialogAction, setDialogAction] = useState(null); // To store the action for the dialog

    const firebaseApp = initializeApp(FIREBASE_API);
    const DB = getFirestore(firebaseApp);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const docRef = doc(DB, `Customers/${searchParams.get('id')}`);
                const response = await getDoc(docRef);
                if (response.exists()) {
                    setCurrentCustomer(response.data());
                    setStatus(response.data().status);
                }
            } catch (err) {
                console.error(err);
            }
            setIsLoading(false);
        };
        fetchData();
    }, []);

    const openImagesInNewTabs = (images) => {
        images?.forEach((url) => {
            window.open(url, '_blank');//window.open: A built-in JavaScript method to open URLs in new tabs or windows.
        });
    };

    const handleApprove = () => {
        setDialogContent("Are you sure you want to approve this customer?");
        setDialogAction(() => async () => {
            const docRef = doc(DB, `Customers/${searchParams.get('id')}`);
            await setDoc(docRef, { status: "Approved", disapproveReason: "",isWholeSaleBuyer:true }, { merge: true });
            setStatus("Approved");
            
        });
        setIsOpen(true);
    };

    const handleDisapproveSubmit = () => {
        setDialogContent("Are you sure you want to disapprove this customer?");
        setDialogAction(() => async () => {
            const docRef = doc(DB, `Customers/${searchParams.get('id')}`);
            await setDoc(docRef, { status: "Disapproved", disapproveReason,isWholeSaleBuyer:false }, { merge: true });
            setStatus("Disapproved");
            setDisapproveReason("");
            setIsDisapproveVisible(false)
          
        });
        setIsOpen(true);
    };

    const handleDialogConfirm =  () => {
        if (dialogAction) {
             dialogAction();
        }
        setIsOpen(false);
    };

    return (
        <Container maxWidth={themeStretch ? false : 'lg'}>
            <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="h4" component="h1">
                    WholeSale Customer Details
                </Typography>
            </Stack>

            {!isLoading && (
                <Card sx={{ mb: "25px", p: "20px" }}>
                    <TableContainer>
                        <Table>
                            <TableBody>
                            <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary', width: '30%' }}>
                                       Name
                                    </TableCell>
                                    <TableCell>{currentCustomer?.fullName}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary', width: '30%' }}>
                                        Business Name
                                    </TableCell>
                                    <TableCell>{currentCustomer?.businessName}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                        Business Address
                                    </TableCell>
                                    <TableCell>{currentCustomer?.businessAddress}</TableCell>
                                </TableRow>
                                
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                        Phone Number
                                    </TableCell>
                                    <TableCell>{currentCustomer?.phone}</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                        Email
                                    </TableCell>
                                    <TableCell>{currentCustomer?.email}</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                        FSSAI Number
                                    </TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Typography>{currentCustomer?.fssaiNumber}</Typography>
                                            <Link
                                                component="button"
                                                variant="body2"
                                                onClick={() =>
                                                    openImagesInNewTabs(currentCustomer?.fssaiImages)
                                                }
                                            >
                                                {currentCustomer?.fssaiImages ? "View Document" : "No Document Available"}
                                            </Link>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                        GST Number
                                    </TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Typography>{currentCustomer?.gstNumber}</Typography>
                                            <Link
                                                component="button"
                                                variant="body2"
                                                onClick={() =>
                                                    openImagesInNewTabs(currentCustomer?.gstImages)
                                                }
                                            >
                                                {currentCustomer?.gstImages ? "View Document" : "No Document Available"}
                                            </Link>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mt={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, marginLeft: "7vw" }}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleApprove}
                                disabled={status === "Approved"}
                                sx={{ width: '5.7vw',color:'white' }}
                            >
                                {status === "Approved" ? "Approved" : "Approve"}
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => setIsDisapproveVisible(!isDisapproveVisible)}
                                disabled={status === "Disapproved"}
                            >
                                {status === "Disapproved" ? "Disapproved" : "Disapprove"}
                            </Button>
                        </Box>
                        {isDisapproveVisible && (
                            <Box mt={2} sx={{ width: '20vw' }}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={disapproveReason}
                                    onChange={(e) => setDisapproveReason(e.target.value)}
                                    placeholder="Enter reason for disapproval"
                                    InputProps={{
                                        style: {
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            padding: '8px',
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&:hover fieldset': {
                                                borderColor: '#ccc',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#ccc',
                                            },
                                        },
                                    }}
                                />
                                <Box mt={2} sx={{ display: 'flex', gap: 2 }}>
                                    <Button
                                        onClick={handleDisapproveSubmit}
                                        variant="contained"
                                        color="error"
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        onClick={() => setIsDisapproveVisible(false)}
                                        color="secondary"
                                    >
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Card>
            )}
            {isLoading && <Typography>Loading...</Typography>}
            <ReusableDialog
                isOpen={isOpen}
                content={dialogContent}
                buttonText="Yes"
                setOpenFunction={(value) => setIsOpen(value)}
                handleDialogConfirm={handleDialogConfirm} // Trigger the action when "Yes" is clicked
            />
        </Container>
    );
};

export default ViewWholeSaleCustomer;
